import React from "react";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";
import SwitchButton from "../Reusable/SwitchButton";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
import { useNavigate } from "react-router-dom";

const DistrictList = (props: any) => {
  const navigate = useNavigate();
  const { handleIsActive } = props;
  const handleRowClick = (row: any) => {
    navigate(`edit/${row.original.id}`);
  };
  const defaultColumns: any = [
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Total Cities",
      accessorKey: "total_state",
      cell: NACell,
    },
    {
      header: "State",
      accessorKey: "district_name.name",
      cell: NACell,
    },
    {
      header: "Country",
      accessorKey: "state_name.name",
      cell: NACell,
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}>
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsActive}
              />
            }
            allowedPermissions={["can_update_setting"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsActive}
              />
            }
          />
        </div>
      ),
    },
    // {
    //   header: "Action",
    //   accessorKey: "id",
    //   cell: ({ row, getValue }: any) => (
    //     <>
    //       <AccessControl
    //         children={<TableActionButton editPath={`edit/${getValue()}`} />}
    //         allowedPermissions={["can_update_setting"]}
    //       />
    //     </>
    //   ),
    // },
  ];
  return (
    <DataTable
      url={`${APIS.LOCATION}flat-location/`}
      queryKey={"districts"}
      columns={defaultColumns}
      params={{ level: 2 }}
      addNewPagePath={"/create-district"}
      tableName={"district"}
      onRowClick={handleRowClick}
    />
  );
};

export default DistrictList;
